import { render, staticRenderFns } from "./Recognition.vue?vue&type=template&id=a9d239fc&scoped=true&"
import script from "./Recognition.vue?vue&type=script&setup=true&lang=js&"
export * from "./Recognition.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Recognition.vue?vue&type=style&index=0&id=a9d239fc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d239fc",
  null
  
)

export default component.exports